export default class UrlParams {

    /**
     * Get url params for host environment
     */
    static get(name) {
        return new URL(window.location.toString()).searchParams.get(name);
    }

    /**
     * Change url Param
     *
     * @param key string
     * @param value string
     */
    static set(key, value) {
        const params = new URLSearchParams(window.location.search.slice(1));
        params.delete(key);
        params.set(key, value);
        const url = unescape(window.location.pathname + '?' + params);
        window.history.replaceState({}, '', url);
    }

}
